import * as React from 'react';
import { useMappedState } from 'redux-react-hook';
import { useCallback } from 'react';
import { DirectoryStoreState } from '../../../types';

export interface NoResultsProps {}

export const NoResults: React.FC<NoResultsProps> = () => {
  const { query } = useMappedState(
    useCallback(
      (state: DirectoryStoreState) => ({
        query: state.stores.searchQuery,
      }),
      []
    )
  );

  return <div className="noResults">{query.length ? `No results found for "${query}"` : ''}</div>;
};
